export default __webpack_public_path__ + "static/media/Timey_White_Blue.d3d9941d.png";